import * as contentful from 'contentful'
import keys from './contentful_keys'

const client = contentful.createClient(keys)

export default (context, mutation) => {

  client.getEntries({
    'content_type': 'allPages',
    include: 5 // resolve nested links
  })
  
  .then((entries) => { // format entries
  
    // let pages = entries.items

    // console.log('pages model')
    // console.log(entries.items)

    let pages = entries.items[0].fields.pages
    
    // .sort((a, b) => {
    //   return a.fields.order - b.fields.order
    // })
    
    .map((item) => {

      // console.log(item)

      let template = item.fields.template.sys.contentType.sys.id
      let content = item.fields.template.fields
      let new_content = {}
      let image = null
      let video = null
      let align = null
      let text_box = null
      let pdf = null
      let videoFile = null
      let textToSpeech = null
      
      for (let key in content) {
        if (Array.isArray(content[key])) {
          let content_fields = content[key].map((entry) => {
            if (key === 'paragraphs') return entry.fields.text
            return entry.fields
          })
          new_content[key] = content_fields
        }
      }

  
      if (item.fields.image) image = item.fields.image.fields.file.url
      if (item.fields.video) video = item.fields.video
      if (item.fields.align) align = item.fields.align
      if (item.fields.text_box) text_box = item.fields.text_box
      if (item.fields.pdf) pdf = item.fields.pdf.fields.file.url
      if (item.fields.textToSpeech) textToSpeech = item.fields.textToSpeech


      // support for uploaded mp4
        if (item.fields.videoFile) {
          videoFile = item.fields.videoFile.fields.file.url
        }
        
      //

      return {
        title: item.fields.title,
        template,
        content: {
          ...new_content,
          image,
          video,
          videoFile,
          align,
          text_box,
          pdf
        },
        textToSpeech
      }
  
    })
    
    let first_pages = [
      {
        // pre survey
        content: {
          image: null,
          video: null,
          align: null,
          text_box: null,
          pdf: null,
        },
        title: 'Pre Survey',
        template: 'pre-survey'
      }
    ]

    let last_pages = [
      {
        // post survey
        content: {
          image: null,
          video: null,
          align: null,
          text_box: null,
          pdf: null,
        },
        title: 'Post Survey',
        template: 'post-survey'
      },
      {
        // sponsors
        content: {
          image: null,
          video: null,
          align: null,
          text_box: null,
          pdf: null,
        },
        title: 'Sponsors',
        template: 'sponsor-page'
      }
    ]
    
    
    // concat hard coded first/last to pages array
    pages = first_pages.concat(pages).concat(last_pages) 


    context.$store.commit(mutation, pages) // commit to Vuex store

  })
}


// WEBPACK FOOTER //
// ./src/contentful/index.js